import React from "react"

import Layout from "../components/layout/layout"
import SEO from "../components/seo"
import { Link } from "gatsby"

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    <section className="section text-center space-xs-up center flex-column" style={{height: '80vh'}}>
      <h1>404: SIDEN KUNNE IKKE FINDES</h1>
      <p>Du har fundet en side der ikke findes</p>
      <Link className="btn btn-secondary" to="/">Gå til forsiden</Link>
    </section>
  </Layout>
)

export default NotFoundPage
